export default __webpack_public_path__ + "static/media/nyc.7efb7931.geojson";